import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TTSlotsPicker.html?raw';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import "../BookingView";

import { TiEntities } from "../TiTypes";

import Multiselect from '../../../moreCore/UI/Multiselect/Multiselect';
import "../../../moreCore/UI/Multiselect/Multiselect";
import ResourcePicker from '../../../moreCore/UI/ResourcePicker/ResourcePicker';
import _uiFrameMixin from '../../../moreCore/UI/Container/uiFrame';
import { DateHelpers, StringHelpers, ToasterHelpers } from "../../../more/Helpers";
import { GenericDialogTypes } from "../../../moreCore/UI/GenericDialog/GenericDialogTypes";
import TiTimeTableSlotEditor from './TTSlotEditor';
const enum TiBookingType {
    "reserved" = 1,
    "booked" = 2
}

interface dataResponse {
    resourcepickerData: ResourcePicker.ResourcePickerConfiguration,
    slots: Array<TiEntities.TimeTableSlotEntity>,
    divisions: Array<TiEntities.DivisionEntity>,
    allowedStatusIDs: Array<string>
}

interface FormData {
    divisions?: Array<string>,
    baseDate: string,
    sectionID: string
}
class TiTimeTableSlotsPicker extends compose(_uiFrameMixin) {

    templateString: any = template;

    
    private btnLater: HTMLElement;
    private btnEarlier: HTMLElement;
    private btnReload: HTMLElement;
    private txtFilterDateLabel: HTMLElement;
    private sectionDivisions: HTMLElement;
    private sectionSlotpicker: HTMLElement;
    private slotPickerContainer: HTMLElement;
    private sectionFloatingOverlay: HTMLElement;

    private slotPicker: MdsLax<InstanceType<typeof ResourcePicker>>;
    private inputDivisions: MdsLax<InstanceType<typeof Multiselect>>;
    private selectableDivisions: Array<TiEntities.DivisionEntity>

    private filterDate: Date;

    private requestData: FormData;
    private sectionID: string;


    setup(config: {
        sectionID: string,
        heading: string,
        selectableDivisions?: Array<TiEntities.DivisionEntity>
    }) {

        if (!config) return;

        
        this.sectionID = config.sectionID;
       


        if (config.selectableDivisions?.length) {
            this.setDivisions(config.selectableDivisions);
        } else {
            this._loadSelectableDivisions();
        }

        if (config.heading) {
            this.setTitles(config.heading);
        }

    }

    private setDivisions(selectableDivisions: Array<TiEntities.DivisionEntity>) {
        this.hideNode(this.sectionDivisions, !selectableDivisions || selectableDivisions.length <= 1);
        
        this.inputDivisions.setData(true, selectableDivisions, false, "name_address", "ID", "coloration");

        this.selectableDivisions = selectableDivisions;
    }

    private _undirtyData: string;
    private serializeData() {
        if (this._serializeDateHandle) clearTimeout(this._serializeDateHandle);

        this._serializeDateHandle = setTimeout(lang.hitch(this, this._serializeData), 600);

        this.disableNode(this.slotPickerContainer);
    }

    private _serializeDateHandle: any = null;
    private _serializeData() {
        let divisions = this.inputDivisions.getValue(false);

    
        let currentData: FormData = {
            baseDate: DateHelpers.dateToLocalISOString(this.filterDate),
            sectionID: this.sectionID,
            divisions: divisions
        };

        // Pflichtangaben?
        if (!currentData.baseDate ||
            !currentData.divisions.length) {
            return;
        }

        if (!this._undirtyData || this._undirtyData != JSON.stringify(currentData)) {
            this.requestData = currentData;
            this._loadTimeTableSlots();
        } else {
            this.disableNode(this.slotPickerContainer, false);
        }

    }

    private _requestHandle: dojo.request.Promise<any>;
    private _loadTimeTableSlots() {
        this.StandbyStart(this.slotPickerContainer, "slots");

        if (this._requestHandle) this._requestHandle.cancel();

        this.disableNode(this.btnReload);

        this._requestHandle = this.RequestManager.callfunction(
            "Webtool_API_TiTimeTableSlotsPanel__LoadSlots",
            this.requestData,
            lang.hitch(this, this._onLoadTimeTableSlotsResponse),
            lang.hitch(this, this._onLoadTimeTableSlotsError)
        );
    }
    private _lastResponse: dataResponse;
    private divisionsReg: Record<string, TiEntities.DivisionEntity>;
    private slotsReg: Record<string, TiEntities.TimeTableSlotEntity>;
    private allowedStatusIDs: Array<string>;
    private _onLoadTimeTableSlotsResponse(response: dataResponse) {
        ToasterHelpers.removeToast("saved");

        this.disableNode(this.slotPickerContainer, false);
        this.disableNode(this.btnReload, false);

        this._lastResponse = response;

        let data = response.resourcepickerData;

        this.allowedStatusIDs = response.allowedStatusIDs;

        this.divisionsReg = {};
        for (let div of response.divisions) {
            this.divisionsReg[div.ID] = div;
        }
        this.slotsReg = {};
        for (let slot of response.slots) {
            this.slotsReg[slot.ID] = slot;
        }

        // das Backend bestimmt die tatsächliche Schrittweite anhand des einen Basisdatums
        // d.h. durch die Response haben wir Datum x Anzahl der Abteilungen
        if (data.groups?.length && this.requestData.divisions.length) {
            this._dateResultWidth = data.groups.length / this.requestData.divisions.length;
            this.changeFilterDate(0);
        }

        if (this.slotPicker) {
            this.slotPicker.setConfiguration(data);
            this.slotPicker.adjustHeightFactorToContent(4);
        }

        this._undirtyData = JSON.stringify(this.requestData);

        this.StandbyStop("slots");
    }

    private _onSelectSlot(values: Array<string>) {
        if (values?.length == 1) {
            let value = values[0];
            let entry = this.slotPicker.getItemByValue(value, true);

            let slotEditor = new TiTimeTableSlotEditor();
            slotEditor.show("dlg");

            slotEditor.on("close", lang.hitch(this, this._onCloseSlotEditor));
            slotEditor.on("change", lang.hitch(this, this.changeFilterDate, 0, true));

            slotEditor.setup(entry.value, entry.label, { targetReassignDivisions: this.selectableDivisions })

        //    // Floatingmenu auf scrollenden verschachtelten Elementen funktioniert einfach nicht... scheiß
        //    let floating = new FloatingMenu();

        //    floating.addEntry({
        //        label: "xxx",
        //        callback: null,
        //        heading: entry.label
        //    });
        //    floating.addEntry({
        //        label: "yyyy",
        //        callback: null,
        //        heading: entry.label
        //    });

        //    debugger;
        //    floating.open(entry.mainLabelNode as any, null, entry.label);

        //    floating.on("close", lang.hitch(this, this._onCloseSlotMenu));
        }
    }

    private _onDialogResult(entry: ResourcePicker.ResourceEntry, result: GenericDialogTypes.GenericDialogResult) {

    }

    private _onCloseSlotEditor() {
        if (this.slotPicker) {
            this.slotPicker.setValue(null, true);
        }
    }

    private _onLoadTimeTableSlotsError(error: more.requestErrorMessage) {
        this.disableNode(this.btnReload, false);

        this.StandbyStop("slots");

        alert("error loading slots: " + error.Message);
    }

    private _onChange_Divisions() {
        this.serializeData();
    }

    private _onClick_Reload(evt: MouseEvent) {
        this.changeFilterDate(0, true);
    }

    private _onClick_ChangeDateBackward(evt: MouseEvent) {
        this.changeFilterDate(-1);
    }
    private _onClick_ChangeDateForward(evt: MouseEvent) {
        this.changeFilterDate(1);
    }
   
    private _currentFilterDateSteps: number = 0;
    private _dateResultWidth: number = 5;
    private _datePagingWidth: number = 4;

    private changeFilterDate(steps: number = 0, forceReload?: boolean) {

        if (steps != 0 && typeof (steps) == "number") {
            this._currentFilterDateSteps = this._currentFilterDateSteps + steps;

            this.filterDate.setHours(24 * this._datePagingWidth * steps);
            this.serializeData();
        }

        else if (forceReload == true) {
            this._undirtyData = "_void_";
            this.serializeData();
        }
        


        this.UiModder.domClass.toggle(this.btnLater, "w3-disabled", this._currentFilterDateSteps >= 12);
        this.UiModder.domClass.toggle(this.btnEarlier, "w3-disabled", this._currentFilterDateSteps <= 0);


        let currentStart = DateHelpers.dateToString(this.filterDate);
        let newDate = new Date(this.filterDate.valueOf());
        newDate.setHours(24 * this._dateResultWidth * 1 - 1); // einen Tag vorher aufhören
        let currentEnd = DateHelpers.dateToString(newDate);
        this.UiModder.domAttr.set(this.txtFilterDateLabel, "innerHTML", this.stringFormat("{0} - {1}", currentStart, currentEnd));

        
        // Sonderrecht mit dem man in die Vergangenheit gehen kann:
        if (this.hasUserRole("TI_AllowPastSlotSelection")) this.UiModder.domClass.toggle(this.btnEarlier, "w3-disabled", this._currentFilterDateSteps <= -4);


    }


    private _loadSelectableDivisions() {
        let data = {};

        this.StandbyStart(this.sectionDivisions, "divisions");

        this._requestHandle = this.RequestManager.callfunction(
            "Webtool_API_TiTimeTableSlotsPanel__GetSelectableDivisions",
            data,
            lang.hitch(this, this._onLoadSelectableDivisionsResponse),
            lang.hitch(this, this._onLoadSelectableDivisionsError)
        );
    }

    private _onLoadSelectableDivisionsResponse(response: Array<TiEntities.DivisionEntity>) {
        this.StandbyStop("divisions");

        this.setDivisions(response);


    }

    private _onLoadSelectableDivisionsError(error: more.requestErrorMessage) {
        this.StandbyStop("divisions");

        alert(error.Message);
    }

    private _onDropGroupDND(data: ResourcePicker.DragDropProcessData<ResourcePicker.GroupDescriptor & { _divisionID: string}>): ResourcePicker.DragDropResultItem {
        //console.debug(this.id + " _onDropGroupDND", data);

        let value = data.draggedNode.getAttribute("data-item-value");


        let droppedItem = this.slotPicker.getItemByValue(value);
        if (droppedItem) {
            let newItem = {
                ...droppedItem
            };

            newItem.groupValue = data.item.groupValue;

            let newEntry: ResourcePicker.ResourceEntry_Stump = {
                groupValue: data.item.groupValue,
                label: droppedItem.label,
                value: droppedItem.value,
                secondaryLabel: droppedItem.secondaryLabel,
                colorBG: data.item.colorBG,
                colorTXT: data.item.colorTXT,
                colorSecondary: droppedItem.colorBG,
                selectable: false
            };
            let division = this.divisionsReg[data.item._divisionID];

            if (!division) return null;

            let dlg = new GenericDialog();
            dlg.setup({
                header: "TiTimeTableSlotsEditor_MessageHeader__ReassignDivision",
                content: StringHelpers.stringFormat("TiTimeTableSlotsEditor_Message__ReassignDivision", division.name_address),
                buttonPreset: "yesno",
                size: "smaller",
                contentIconClass: "fas fa-reply fa-flip-vertical fa-flip-horizontal",
                callback: lang.hitch(this, this._onConfirmDragDropResult, newEntry, division.ID)
            });

            dlg.show();

            return null;
        }

        return null;
    }


    private _onConfirmDragDropResult(newEntry: ResourcePicker.ResourceEntry_Stump, divisionID: string, result: GenericDialogTypes.GenericDialogResult) {
        if (result == GenericDialogTypes.GenericDialogResult.yes) {
            this.slotPicker.updateItem(newEntry);

            this.saveReassignment(newEntry.value, divisionID);
        }
    }

    private _onCheckGroupDND(data: ResourcePicker.DragDropProcessData<ResourcePicker.GroupDescriptor>): boolean {
        //console.debug(this.id + " _onCheckGroupDND", data);

        let grp = this.slotPicker.getGroupByValue(data.item.groupValue) as (ResourcePicker.GroupDescriptor & { _dateValue: Date, _divisionID: string });
        let itemID = data.draggedNode.getAttribute("data-item-value");
        let item = this.slotPicker.getItemByValue(itemID) as ResourcePicker.ResourceEntry & { _dateValue: Date, _divisionID: string };
        if (grp && item) {
            if (grp._dateValue && grp._dateValue.valueOf() == item._dateValue.valueOf()) {
                if (grp._divisionID != item._divisionID) {

                    return true;
                }
            }
            
        }
        
        return false;
    }
    private _onDroppedItemDND(data: ResourcePicker.DragDropProcessData<ResourcePicker.ResourceEntry>): boolean {
        //console.debug(this.id + " _onDroppedItemDND", data);

        return false;
    }
    private _onCheckItemDropDND(data: ResourcePicker.DragDropProcessData<ResourcePicker.ResourceEntry>): boolean {
        //console.debug(this.id + " _onCheckItemDropDND", data);

        return true;
    }
    private _onCheckItemDND(data: ResourcePicker.DragDropProcessData<ResourcePicker.ResourceEntry & { _dateValue: Date }>): boolean {
        //console.debug(this.id + " _onCheckItemDND", data);
        let itemDate = data.item._dateValue;
        let slot = this.slotsReg[data.item.value];

        let now = new Date();
        //now.setHours(24 * 1); // x Tage nach vorne damit was auswählbar wird
        now.setHours(0, 0, 0, 0);
        
        if (itemDate.valueOf() > now.valueOf()) {
            if (this.allowedStatusIDs.indexOf(slot.ref_status_timeslot.ID) != -1) {

                return true;
            }
        }
        return false;
    }

    private saveReassignment(slotID: string, newDivisionID: string) {
        let data = {
            slotID: slotID,
            action: "reassign",
            data: {
                targetDivisionID: newDivisionID,
            }
        };

        this.StandbyStart(this.sectionSlotpicker);

        this.RequestManager.callfunction(
            "Webtool_API_TiTimeTableSlotsEditor__SlotAction",
            data,
            lang.hitch(this, this._onSaveReassignmentResponse),
            lang.hitch(this, this._onSaveReassignmentError),
            true
        );
    }

    private _onSaveReassignmentResponse(response: { success: boolean, message?: string }) {
        if (!response.success) {
            let dlg = new GenericDialog();
            dlg.show(response.message, null, null, toasterIcons.warning, "ok");
        } else {
            ToasterHelpers.showToast("TiTimeTableSlotsEditor_SaveSuccessToast", toasterIcons.confirmCheck, "saved");
        }
        this.StandbyStop();
        this.changeFilterDate(0, true);
    }

    private _onSaveReassignmentError(error: more.requestErrorMessage) {
        let dlg = new GenericDialog();
        dlg.setup({
            content: error.Message,
            contentIconClass: toasterIcons.error,
            header: "TiTimeTableSlotsEditor_MessageHeader__SlotActionFailed",
            size: "smaller"
        });

        this.StandbyStop();
        this.changeFilterDate(0, true);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
        this.useStandbyManager = true;
        
        this.filterDate = new Date();
        this.filterDate.setHours(12, 0, 0, 0);
        //
        this.filterDate.setHours(24 * this._datePagingWidth * -1);

        this.changeFilterDate(1);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        let resourcePicker = new ResourcePicker();
        resourcePicker.placeAt(this.slotPickerContainer, "only");

        resourcePicker.on("change", lang.hitch(this, this._onSelectSlot));

        resourcePicker.setupDragAndDrop({
            groupDropReceivedCallback: lang.hitch(this, this._onDropGroupDND),
            groupEnableDropCallback: lang.hitch(this, this._onCheckGroupDND),
            itemDroppedCallback: lang.hitch(this, this._onDroppedItemDND),
            itemEnableDragCallback: lang.hitch(this, this._onCheckItemDND),
            itemEnableDropCallback: lang.hitch(this, this._onCheckItemDropDND)
        })

        this.slotPicker = resourcePicker;
    }
}

export default mdsWidget(TiTimeTableSlotsPicker);
